import { ofType } from 'redux-observable';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { EMPTY, from, of, concat, defer, iif, debounceTime } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_CONFIGURATION_LIST } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  setPopupInfo,
  storeConfigurationListAction,
} from '../../data.action';
import { filler } from '../../../../../utils/utils';
import { selectConfigurationList } from '../../data.selector';

const retrieveConfigurationListEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_CONFIGURATION_LIST),
    debounceTime(20),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_CONFIGURATION_LIST}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, state]) => {
      return concat(
        of(setLoaders({ configurationLoader: true })),
        iif(
          () => body?.pageSize <= 100,
          of(setListConfigAction({ configuration: body })),
          EMPTY
        ),
        defer(() =>
          from(
            request({
              path: `configuration/list`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }

              // lazy load
              if (body?.append) {
                const currentList = selectConfigurationList(state)?.result;
                return {
                  total: p?.total,
                  result: [...(currentList ?? []), ...p?.result],
                };
              }

              return {
                total: p?.total,
                result: [...p?.result, ...filler],
              };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_CONFIGURATION_LIST}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storeConfigurationListAction(data))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_CONFIGURATION_LIST}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ configurationLoader: false }))
      );
    })
  );

export default retrieveConfigurationListEpic;
